import React, { useState } from "react";
import { Share, Check } from "lucide-react";
import ShareLinkModal from "./ui/ShareLinkModal";

const ShareDashboardButton = ({
  dateFilterType,
  singleDate,
  dateRangeStart,
  dateRangeEnd,
  commissionPercentage,
  sortConfig,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const handleShareClick = () => {
    // Build URL with current filter state
    const params = new URLSearchParams();

    // Add date filter parameters
    if (dateFilterType !== "all") {
      params.append("dateFilter", dateFilterType);
      if (singleDate) {
        params.append("date", singleDate);
      }
      if (dateRangeStart) {
        params.append("startDate", dateRangeStart);
      }
      if (dateRangeEnd) {
        params.append("endDate", dateRangeEnd);
      }
    }

    // Add commission percentage if different from default
    if (commissionPercentage !== 0.048) {
      // DEFAULT_COMMISSION_PERCENTAGE
      params.append("commission", commissionPercentage.toString());
    }

    // Add sort configuration
    if (sortConfig.key) {
      params.append("sortBy", sortConfig.key);
      params.append("sortDir", sortConfig.direction);
    }

    // Build the shareable URL
    const baseUrl = `${window.location.origin}${window.location.pathname}`;
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;

    setShareUrl(url);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setShareUrl("");
  };

  return (
    <>
      <button
        onClick={handleShareClick}
        className="fixed bottom-6 right-6 w-14 h-14 bg-blue-500 hover:bg-blue-600 text-white rounded-full shadow-xl hover:shadow-2xl transition-all duration-200 flex items-center justify-center z-50 hover:scale-110"
        title="Share dashboard with current filters"
      >
        <Share className="h-6 w-6" />
      </button>

      <ShareLinkModal
        isOpen={isModalOpen}
        onClose={closeModal}
        link={shareUrl}
        title="Share Dashboard"
      />
    </>
  );
};

export default ShareDashboardButton;
